module.exports = __webpack_public_path__ + "img/banner-bg.f8d2da3e.jpg";